import type { ICheckTicketResponse, IUser } from '@/types/auth';

import HTTP from '@/utils/http';

export const AuthAPI = {
  whoAmI: () => HTTP.get<IUser>('auth/whoami'),
  checkTicket: (ticket: string, service: string) => HTTP.post<ICheckTicketResponse>('auth/login', { ticket, service }),
  logout: () => HTTP.post('auth/logout'),
};
